import { useState, useEffect, useRef, useCallback } from 'react'
import { trackingAPI } from '../../api'
import '../TrackingService/TrackingService.css'

// ── Utilitaires ───────────────────────────────────────────────────────────
const timeToMin = (t) => { if (!t) return 0; const [h, m] = t.split(':').map(Number); return h * 60 + (m || 0) }

// ── Dessin chien ──────────────────────────────────────────────────────────
const drawDog = (ctx, cx, cy, flip = true) => {
  ctx.save(); ctx.translate(cx, cy)
  if (flip) ctx.scale(-1, 1)
  ctx.scale(1.15, 1.15)
  ctx.beginPath(); ctx.arc(0, 0, 17, 0, 2 * Math.PI); ctx.fillStyle = 'rgba(29,158,117,0.2)'; ctx.fill()
  ctx.beginPath(); ctx.ellipse(-1, 3, 10, 6, -0.15, 0, 2 * Math.PI); ctx.fillStyle = '#C8832A'; ctx.fill()
  ctx.beginPath(); ctx.arc(-11, -3, 7, 0, 2 * Math.PI); ctx.fillStyle = '#C8832A'; ctx.fill()
  ctx.beginPath(); ctx.ellipse(-16, -1, 3.5, 2.5, 0, 0, 2 * Math.PI); ctx.fillStyle = '#A0622A'; ctx.fill()
  ctx.beginPath(); ctx.arc(-18, -2, 1.4, 0, 2 * Math.PI); ctx.fillStyle = '#111'; ctx.fill()
  ctx.beginPath(); ctx.arc(-10, -5.5, 1.8, 0, 2 * Math.PI); ctx.fillStyle = '#111'; ctx.fill()
  ctx.beginPath(); ctx.arc(-9.3, -6.2, 0.6, 0, 2 * Math.PI); ctx.fillStyle = 'rgba(255,255,255,0.7)'; ctx.fill()
  ctx.beginPath(); ctx.ellipse(-8, -9, 3.5, 5, -0.4, 0, 2 * Math.PI); ctx.fillStyle = '#9B5E1A'; ctx.fill()
  ctx.beginPath(); ctx.moveTo(8, 0); ctx.quadraticCurveTo(15, -7, 11, -14)
  ctx.lineWidth = 3.5; ctx.strokeStyle = '#9B5E1A'; ctx.lineCap = 'round'; ctx.stroke()
  ctx.lineWidth = 2.8; ctx.strokeStyle = '#A0622A'; ctx.lineCap = 'round'
  ;[[-7,9,-8,16],[-2,9,-2,16],[3,9,4,16],[7,8,8,15]].forEach(([x1,y1,x2,y2]) => {
    ctx.beginPath(); ctx.moveTo(x1,y1); ctx.lineTo(x2,y2); ctx.stroke()
  })
  ctx.restore()
}

// ── Canvas carte ──────────────────────────────────────────────────────────
const drawMapOnCanvas = (canvas, ship, progress, adjWps) => {
  if (!canvas || !ship) return
  const wps = adjWps || ship.waypoints
  if (!wps || wps.length < 2) return
  const ctx = canvas.getContext('2d')
  const w = canvas.width, h = canvas.height
  if (w === 0 || h === 0) return
  ctx.clearRect(0, 0, w, h)
  ctx.fillStyle = '#f0efe7'; ctx.fillRect(0, 0, w, h)
  const n = wps.length - 1, margin = 60, usableW = w - 2 * margin
  const startMin = timeToMin(wps[0].time)
  let prevMin = startMin
  const absMin = wps.map((wp, i) => { let m = timeToMin(wp.time); if (i > 0 && m < prevMin) m += 1440; prevMin = m; return m })
  const totalDur = absMin[n] - absMin[0]
  const pos = absMin.map(m => totalDur > 0 ? margin + ((m - absMin[0]) / totalDur) * usableW : margin + (absMin.indexOf(m) / Math.max(n,1)) * usableW)
  const startX = pos[0], endX = pos[n]
  let curX
  if (progress >= 1) curX = endX
  else if (progress <= 0) curX = startX
  else {
    const thresh = absMin.map(m => totalDur > 0 ? (m - absMin[0]) / totalDur : 0)
    let si = n - 1
    for (let i = 0; i < n; i++) { if (progress >= thresh[i] && progress < thresh[i+1]) { si = i; break } }
    const sf = thresh[Math.min(si+1,n)] > thresh[si] ? (progress - thresh[si]) / (thresh[Math.min(si+1,n)] - thresh[si]) : 0
    curX = pos[si] + (pos[Math.min(si+1,n)] - pos[si]) * sf
  }
  ctx.beginPath(); ctx.moveTo(pos[0], h/2); pos.slice(1).forEach(x => ctx.lineTo(x, h/2)); ctx.strokeStyle='#ddd'; ctx.lineWidth=4; ctx.stroke()
  ctx.beginPath(); ctx.moveTo(pos[0], h/2)
  for (let i = 1; i < pos.length; i++) { if (pos[i] <= curX) ctx.lineTo(pos[i], h/2); else { ctx.lineTo(curX, h/2); break } }
  ctx.strokeStyle='#1D9E75'; ctx.lineWidth=4; ctx.stroke()
  pos.forEach((x, i) => {
    const color = wps[i].type==='start' ? '#1D9E75' : wps[i].type==='end' ? '#D85A30' : '#378ADD'
    ctx.beginPath(); ctx.arc(x, h/2, 8, 0, 2*Math.PI); ctx.fillStyle=color; ctx.fill()
    ctx.font='12px sans-serif'; ctx.textAlign='center'
    if (wps[i].type==='start') ctx.fillText('🚩', x, h/2+4)
    else if (wps[i].type==='end') ctx.fillText('🏁', x, h/2+4)
    else ctx.fillText('📍', x, h/2+4)
    ctx.fillStyle='#333'; ctx.font='bold 10px sans-serif'
    ctx.fillText(wps[i].name.length>12 ? wps[i].name.slice(0,10)+'…' : wps[i].name, x, h/2-14)
    ctx.fillStyle='#888'; ctx.font='9px monospace'; ctx.fillText(wps[i].time, x, h/2-4)
  })
  const dogY = h/2 - 22
  if (progress >= 1) drawDog(ctx, endX, dogY, true)
  else if (progress > 0) drawDog(ctx, curX, dogY, true)
  else drawDog(ctx, startX, dogY, true)
}

// ── Timeline (identique à TrackingService) ────────────────────────────────
const renderTimeline = (waypoints, progress) => {
  if (!waypoints || waypoints.length === 0) return null
  const startMin = timeToMin(waypoints[0].time)
  let prevMin = startMin
  const tl = waypoints.map((wp, i) => {
    let cur = timeToMin(wp.time); if (i > 0 && cur < prevMin) cur += 1440
    const off = cur - startMin; prevMin = cur
    return { ...wp, minutesFromStart: off >= 0 ? off : off + 1440 }
  })
  const totalDur = tl[tl.length-1].minutesFromStart
  let activeIdx = -1
  for (let i = 0; i < tl.length-1; i++) {
    if (progress >= tl[i].minutesFromStart/totalDur && progress < tl[i+1].minutesFromStart/totalDur) { activeIdx = i; break }
  }
  if (progress >= 1) activeIdx = tl.length - 1
  return tl.map((wp, i) => {
    const wpProg  = wp.minutesFromStart / totalDur
    const isPassed = progress >= wpProg
    const isActive = i === activeIdx
    const isStart = wp.type==='start', isEnd = wp.type==='end', isMid = wp.type==='mid'
    let dotClass = 'step-pending', statusText = ''
    if (isStart) {
      dotClass = progress <= 0 ? 'start-pulse' : 'start-done'
      statusText = progress <= 0 ? 'Départ imminent' : 'Départ effectué ✓'
    } else if (isEnd) {
      if (progress >= 1)       { dotClass = 'end-done';    statusText = 'Arrivée à destination ✓' }
      else if (isActive) {
        dotClass = 'end-pulse'
        const rem = wp.minutesFromStart - progress*totalDur
        statusText = rem < 60 ? `Arrivée dans ~${Math.round(rem)} min` : `Arrivée dans ~${Math.floor(rem/60)}h${Math.round(rem%60)>0?` ${Math.round(rem%60)}min`:''}`
      } else { dotClass = 'end-pending'; statusText = 'Arrivée prévue' }
    } else if (isMid) {
      if (isPassed)      { dotClass = 'step-done';         statusText = 'Étape complétée ✓' }
      else if (isActive) {
        dotClass = 'step-active-pulse'
        const rem = wp.minutesFromStart - progress*totalDur
        statusText = rem < 60 ? `En route — ~${Math.round(rem)} min` : `En route — ~${Math.floor(rem/60)}h${Math.round(rem%60)>0?` ${Math.round(rem%60)}min`:''}`
      } else { dotClass = 'step-pending'; statusText = 'À venir' }
    }
    return (
      <div key={i} className="tl-row">
        <div className={`tl-dot ${dotClass}`} />
        <div className="tl-content">
          <div className="tl-name">{isStart&&'🚩 '}{isEnd&&'🏁 '}{isMid&&'📍 '}{wp.name}</div>
          <div className="tl-time">⏰ {wp.time}</div>
          <div className="tl-status">{statusText}</div>
        </div>
      </div>
    )
  })
}

// ── Calcul statut réel (identique à computeProgress mais hors hook) ──────
const calcRealProgress = (trip) => {
  const prog = trip?.progress
  if (!prog) return 0
  // Arrivé si sauvegardé >= 1
  if ((prog.progressAtStart || 0) >= 1) return 1
  if (!prog.isPlaying) return Math.min(Math.max(prog.progressAtStart ?? 0, 0), 1)
  const wps = trip.waypoints
  if (!wps || wps.length < 2) return prog.progressAtStart || 0
  const startMin = (() => { const [h,m]=(wps[0].time||'0:0').split(':').map(Number); return h*60+m })()
  let prevMin = startMin
  const absMin = wps.map((wp, i) => {
    const [h,m]=(wp.time||'0:0').split(':').map(Number); let cur=h*60+m
    if (i>0 && cur<prevMin) cur+=1440; prevMin=cur; return cur
  })
  const totalDur = absMin[absMin.length-1] - absMin[0]
  if (totalDur <= 0) return prog.progressAtStart || 0
  let elapsed = 0
  if (prog.startedAt) {
    elapsed = (Date.now() - new Date(prog.startedAt)) / 60000
  } else {
    const now = new Date(); let nowMin = now.getHours()*60+now.getMinutes()+now.getSeconds()/60
    if (nowMin < startMin && absMin[absMin.length-1] > 1440) nowMin += 1440
    elapsed = nowMin - startMin
  }
  const raw = (prog.progressAtStart || 0) + (elapsed - (prog.pauseOffsetMinutes || 0)) / totalDur
  return Math.min(Math.max(raw, 0), 1)
}

const getTripStatus = (trip) => {
  const real    = calcRealProgress(trip)
  const pct     = Math.min(Math.round(real * 100), 100)
  const playing = (trip?.progress?.isPlaying === true) && pct < 100
  return { pct, playing }
}

// ── Composant ─────────────────────────────────────────────────────────────
export default function TransportView({ myTrips: myTripsProp, tripsLoading, onReload, API_URL }) {
  const myTrips = Array.isArray(myTripsProp) ? myTripsProp : Object.values(myTripsProp || {})

  const [searchCode,    setSearchCode]    = useState('')
  const [searchError,   setSearchError]   = useState('')
  const [searching,     setSearching]     = useState(false)
  const [activeShip,    setActiveShip]    = useState(null)
  const [showResult,    setShowResult]    = useState(false)
  // ID du trip de la liste actuellement ouvert (pour le toggle)
  const [openTripId,    setOpenTripId]    = useState(null)
  const [progress,      setProgress]      = useState(0)
  const [tripsProgress, setTripsProgress] = useState({})

  const canvasRef     = useRef(null)
  const rafRef        = useRef(null)
  const activeShipRef = useRef(null)
  const tpRef         = useRef({})
  useEffect(() => { tpRef.current = tripsProgress }, [tripsProgress])
  useEffect(() => { activeShipRef.current = activeShip  }, [activeShip])

  // ── Calcul progression réelle ─────────────────────────────────────────
  const computeProgress = useCallback((ship) => {
    if (!ship) return 0
    const meta = tpRef.current[ship.id] || ship.progress
    if (!meta) return 0
    // Arrivé si progressAtStart >= 1
    if ((meta.progressAtStart || 0) >= 1) return 1
    if (!meta.isPlaying) return Math.min(Math.max(meta.progressAtStart ?? 0, 0), 1)
    const { progressAtStart = 0, pauseOffsetMinutes = 0, startedAt } = meta
    const wps = ship.waypoints
    if (!wps || wps.length < 2) return progressAtStart
    const startMin = timeToMin(wps[0].time)
    let prevMin = startMin
    const absMin = wps.map((wp, i) => { let m = timeToMin(wp.time); if (i>0 && m<prevMin) m+=1440; prevMin=m; return m })
    const totalDur = absMin[absMin.length-1] - absMin[0]
    if (totalDur <= 0) return progressAtStart
    let elapsed = 0
    if (startedAt) {
      elapsed = (Date.now() - new Date(startedAt)) / 60000
    } else {
      const now = new Date()
      let nowMin = now.getHours()*60 + now.getMinutes() + now.getSeconds()/60
      if (nowMin < startMin && absMin[absMin.length-1] > 1440) nowMin += 1440
      elapsed = nowMin - startMin
    }
    return Math.min(Math.max(progressAtStart + (elapsed - pauseOffsetMinutes) / totalDur, 0), 1)
  }, [])

  // ── SSE ───────────────────────────────────────────────────────────────
  useEffect(() => {
    const sse = new EventSource(`${API_URL}/events`)
    sse.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data)
        if (msg.type !== 'progress_update') return
        const { tripId, isPlaying, startedAt, pauseOffsetMinutes, progressAtStart } = msg
        setTripsProgress(prev => {
          const loc = prev[tripId] || {}
          return { ...prev, [tripId]: { ...loc, progressAtStart: progressAtStart ?? loc.progressAtStart ?? 0, isPlaying: isPlaying ?? false, startedAt: startedAt ?? null, pauseOffsetMinutes: pauseOffsetMinutes ?? loc.pauseOffsetMinutes ?? 0 } }
        })
      } catch (err) { /* ignore */ }
    }
    sse.onerror = () => sse.close()
    return () => sse.close()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ── Polling 5s quand résultat actif ──────────────────────────────────
  useEffect(() => {
    if (!showResult || !activeShip) return
    const poll = async () => {
      try {
        const d = await trackingAPI.getById(activeShip.id)
        if (d?.progress) {
          setTripsProgress(prev => ({
            ...prev,
            [activeShip.id]: { progressAtStart: d.progress.progressAtStart ?? 0, isPlaying: d.progress.isPlaying ?? false, startedAt: d.progress.startedAt ?? null, pauseOffsetMinutes: d.progress.pauseOffsetMinutes ?? 0 }
          }))
        }
      } catch (e) { /* silencieux */ }
    }
    poll(); const iv = setInterval(poll, 5000); return () => clearInterval(iv)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showResult, activeShip])

  // ── Boucle RAF canvas ─────────────────────────────────────────────────
  useEffect(() => {
    if (!showResult || !activeShip) { if (rafRef.current) cancelAnimationFrame(rafRef.current); return }
    const loop = () => {
      const ship = activeShipRef.current; if (!ship || !canvasRef.current) return
      const prog = computeProgress(ship)
      setProgress(prog)
      const canvas = canvasRef.current
      if (canvas?.parentElement) {
        const cw = canvas.parentElement.clientWidth, ch = canvas.parentElement.clientHeight
        if (canvas.width !== cw || canvas.height !== ch) { canvas.width = cw; canvas.height = ch }
        drawMapOnCanvas(canvas, ship, prog, ship.waypoints)
      }
      rafRef.current = requestAnimationFrame(loop)
    }
    rafRef.current = requestAnimationFrame(loop)
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current) }
  }, [showResult, activeShip, computeProgress])

  // ── Charger un trip (depuis recherche ou depuis liste) ────────────────
  const openTrip = (trip, prog) => {
    setActiveShip(trip)
    if (prog) setTripsProgress(prev => ({ ...prev, [trip.id]: { progressAtStart: prog.progressAtStart ?? 0, isPlaying: prog.isPlaying ?? false, startedAt: prog.startedAt ?? null, pauseOffsetMinutes: prog.pauseOffsetMinutes ?? 0 } }))
    setShowResult(true); setSearchError('')
    setTimeout(() => document.querySelector('.tv-result')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)
  }

  // ── Recherche par code ANI ────────────────────────────────────────────
  const doSearch = async () => {
    const code = searchCode.trim().toUpperCase()
    if (!code) { setSearchError('Entrez un numéro de suivi'); return }
    setSearching(true); setSearchError(''); setShowResult(false); setActiveShip(null); setOpenTripId(null)
    try {
      const d = await trackingAPI.getById(code)
      if (d?.trip) { openTrip(d.trip, d.progress) }
      else { setSearchError(`Numéro "${code}" introuvable.`) }
    } catch (e) { setSearchError(`Numéro "${code}" introuvable.`) }
    finally { setSearching(false) }
  }

  // ── Toggle depuis la liste des trajets ────────────────────────────────
  const toggleTrip = (trip) => {
    const tripId = trip.id || trip.trackingId
    if (openTripId === tripId && showResult) {
      // Fermer
      setShowResult(false); setActiveShip(null); setOpenTripId(null)
      if (rafRef.current) cancelAnimationFrame(rafRef.current)
    } else {
      // Ouvrir
      setOpenTripId(tripId); setSearchCode('')
      openTrip(trip, trip.progress)
    }
  }

  // ── Statut display ────────────────────────────────────────────────────
  const getActivePct = () => Math.round(Math.min(computeProgress(activeShip), 1) * 100)
  const isActivePlaying = () => {
    const meta = activeShip ? (tpRef.current[activeShip.id] || activeShip.progress) : null
    return meta?.isPlaying === true && getActivePct() < 100
  }

  const wps = activeShip?.waypoints || []
  const pct = getActivePct()
  const playing = isActivePlaying()

  return (
    <div className="tv-wrap">

      {/* ── HERO RECHERCHE — couleurs du site ──────────────────────────── */}
      <div className="ud-card" style={{ padding: 0, overflow: 'hidden', marginBottom: 16 }}>
        <div className="tv-hero-site">
          <div className="tv-hero-top">
            <span className="tv-section-label">Suivi en temps réel</span>
            <h2 className="tv-hero-title">Où est mon animal ?</h2>
            <p className="tv-hero-sub">Entrez le numéro de suivi reçu lors de la prise en charge</p>
          </div>
          <div className="tv-search-area">
            <div className="tracking-search-row" style={{ margin: 0, maxWidth: '100%', justifyContent: 'flex-start' }}>
              <input
                type="text"
                placeholder="ANI-XXXX"
                value={searchCode}
                onChange={e => { setSearchCode(e.target.value.toUpperCase()); setSearchError('') }}
                onKeyDown={e => e.key === 'Enter' && doSearch()}
              />
              <button className="tracking-btn tracking-btn-green" onClick={doSearch} disabled={searching}>
                {searching ? '🔍 Recherche…' : '🔍 Rechercher'}
              </button>
            </div>
            {searchError && <div className="tracking-err">{searchError}</div>}
            <div className="tv-hero-note">💡 Numéro communiqué lors de la prise en charge de votre animal</div>
          </div>
        </div>

        {/* ── Résultat de recherche ─────────────────────────────────── */}
        {showResult && activeShip && (
          <div className="tv-result tracking-client-result" style={{ padding: '0 28px 24px' }}>
            <div className="tracking-info-grid" style={{ marginTop: 20 }}>
              <div className="tracking-metric">
                <div className="tracking-ml">Animal</div>
                <div className="tracking-mv">{activeShip.animal} · {activeShip.species}</div>
              </div>
              <div className="tracking-metric">
                <div className="tracking-ml">Statut</div>
                <div className="tracking-mv">
                  {pct <= 0  && <span className="tracking-badge tracking-badge-wait">⏳ Départ imminent</span>}
                  {pct >= 100 && <span className="tracking-badge tracking-badge-done">✅ Arrivé à destination</span>}
                  {pct > 0 && pct < 100 && !playing && <span className="tracking-badge tracking-badge-pause">⏸ En arrêt</span>}
                  {pct > 0 && pct < 100 &&  playing && <span className="tracking-badge tracking-badge-transit">🚚 En transit</span>}
                </div>
              </div>
              <div className="tracking-metric">
                <div className="tracking-ml">Départ</div>
                <div className="tracking-mv">{wps[0]?.name} · {wps[0]?.time}</div>
              </div>
              <div className="tracking-metric">
                <div className="tracking-ml">Arrivée prévue</div>
                <div className="tracking-mv">{wps[wps.length-1]?.name} · {wps[wps.length-1]?.time}</div>
              </div>
            </div>

            {/* Canvas */}
            <div className="tracking-map-card">
              <div className="tracking-map-wrap" style={{ height: 90 }}>
                <canvas ref={canvasRef} className="tracking-canvas" />
              </div>
            </div>

            {/* Barre de progression */}
            <div className="tracking-prog-wrap">
              <div className="tracking-prog-bar" style={{ width: `${pct}%` }} />
            </div>
            <div className="tracking-prog-row">
              <span>{wps[0]?.name}</span>
              <span>{pct}%</span>
              <span>{wps[wps.length-1]?.name}</span>
            </div>

            {/* Timeline — identique TrackingService */}
            <div className="tracking-card" style={{ marginTop: 16 }}>
              <h4>📌 Étapes du parcours</h4>
              {renderTimeline(wps, progress)}
            </div>

            <div className="tracking-saved-progress">
              💾 Progression actuelle : {pct}%
              {pct > 0 && pct < 100 && playing && <span> — L'animal continue son trajet en temps réel</span>}
            </div>
          </div>
        )}
      </div>

      {/* ── LISTE DES TRAJETS ASSIGNÉS ────────────────────────────────── */}
      <div className="ud-card">
        <div className="ud-card-head">
          <div className="ud-card-title">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
            {' '}Tous mes trajets
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span className="ud-card-count">{myTrips.length}</span>
            <button className="ud-edit-btn" onClick={onReload}>↻ Actualiser</button>
          </div>
        </div>

        {tripsLoading ? (
          <div className="ud-empty"><div className="catalog-spinner" /><p>Chargement…</p></div>
        ) : myTrips.length === 0 ? (
          <div className="ud-empty">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity:0.3 }}><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
            <p>Aucun transport assigné pour l'instant.</p>
            <p style={{ fontSize:12, color:'var(--slate-lt)', marginTop:4 }}>Votre animal apparaîtra ici dès que l'administrateur assignera un numéro de suivi à votre compte.</p>
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {myTrips.map(trip => {
              const tripId  = trip.id || trip.trackingId
              const { pct: tPct, playing: tPlaying } = getTripStatus(trip)
              const isOpen  = openTripId === tripId && showResult && activeShip?.id === tripId
              const firstWp = trip.waypoints?.[0]
              const lastWp  = trip.waypoints?.[trip.waypoints.length-1]
              return (
                <div key={tripId} className={`tv-trip-row${isOpen ? ' tv-trip-row-open' : ''}`}>
                  <div className="tv-trip-left">
                    <div className="tv-trip-icon">{tPlaying ? '🚚' : tPct >= 100 ? '✅' : '🐾'}</div>
                    <div className="tv-trip-info">
                      <div className="tv-trip-name">
                        {trip.animal}
                        <span className="tv-species"> · {trip.species}</span>
                      </div>
                      <div className="tv-trip-route">
                        <span>🚩 {firstWp?.name || '—'}</span>
                        <span className="tv-route-arrow">→</span>
                        <span>🏁 {lastWp?.name || '—'}</span>
                      </div>
                      <div className="tv-trip-meta">
                        <span className="tv-track-id-sm">{tripId}</span>
                        {trip.date && <span>· {trip.date}</span>}
                        {trip.totalDurationMinutes > 0 && (() => { const h=Math.floor(trip.totalDurationMinutes/60), m=trip.totalDurationMinutes%60; return <span>· ⏱ {h>0?`${h}h${m>0?` ${m}min`:''}`:``}{h===0?`${m}min`:``}</span> })()}
                      </div>
                      {/* Mini barre */}
                      <div className="tv-prog-mini">
                        <div className="tv-prog-mini-bar">
                          <div className="tv-prog-mini-fill" style={{ width:`${tPct}%`, background: tPct>=100 ? 'var(--green-dk)' : 'var(--gold)' }} />
                        </div>
                        <span className="tv-prog-mini-pct">{tPct}%</span>
                      </div>
                    </div>
                  </div>
                  <div className="tv-trip-right">
                    {/* Badge statut — corrigé : progressAtStart >= 1 → Arrivé */}
                    <span className={`tracking-badge ${tPct>=100 ? 'tracking-badge-done' : tPlaying ? 'tracking-badge-transit' : tPct>0 ? 'tracking-badge-pause' : 'tracking-badge-wait'}`}>
                      {tPct>=100 ? '✅ Arrivé' : tPlaying ? '🚚 En transit' : tPct>0 ? '⏸ En arrêt' : '⏳ Imminent'}
                    </span>
                    {/* Bouton œil — toggle */}
                    <button
                      className={`ud-action-btn${isOpen ? ' ud-action-del' : ''}`}
                      title={isOpen ? 'Fermer le suivi' : 'Voir le suivi'}
                      onClick={() => toggleTrip(trip)}
                    >
                      {isOpen ? '✕' : '👁'}
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}